export default "__VITE_ASSET__gkt85oZW__"